import { GENERIC_USER_PROFILE_QUERY } from "@/graphql/accounts";
import { useQuery } from "@apollo/client";

export default function useUserProfile() {
  const { data, loading } = useQuery(GENERIC_USER_PROFILE_QUERY, {
    fetchPolicy: "cache-first",
  });

  return {
    loading,
    isPatient: !!data?.user?.patientProfile?.id,
    isPractitioner: !!data?.user?.practitionerProfile?.id && data?.user?.practitionerProfile?.approved,
    patientProfile: data?.user?.patientProfile,
    practitionerProfile: data?.user?.practitionerProfile,
    user: data?.user
  };
}
